const EMAIL_REGEX = /[\w+\-.]+@[a-z\d]+(\.[a-z\d]+)*\.[a-z]+/i;

export const NameValidator = {
  required: true,
};

export const EmailValidator = {
  pattern: EMAIL_REGEX,
};
